/** Добавляет query для обхода кэша (аудио/видео/обложки), когда пользователь жмёт «обновить». */
export function mediaUrlWithCacheBust(path: string | undefined | null, bust: number): string {
  if (path == null || path === "") return "";
  const trimmed = String(path).trim();
  const base = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  if (!bust) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}v=${bust}`;
}
